import {configureStore} from '@reduxjs/toolkit'
import {rootReducer} from './root-reducers'

export default configureStore({
  reducer: rootReducer,
})
